module.exports = __webpack_public_path__ + "img/3.e3d8939e.jpg";